module.exports = __webpack_public_path__ + "static/media/vert.73248cfc.png";